// removed by extract-text-webpack-plugin
module.exports = {"button":"_2hYv2do8HV0VkjDUmR38JN","is-compact":"_38T-62coNKh4SdCBHu38ll","gridicon":"_5ySL4Y8q4ILp3cOCANR8-","hidden":"_2V8mraeiYNYyl2rp__2sIM","is-primary":"_2Iv9aRNZENrHCN9nwfA74j","is-scary":"h3Og3URfrNB1KXcO8Y6N8","is-dangerous":"_2W3P9tn-oQkEPcoqlQYCVt","is-destructive":"_1s_LBF19rmbD-SXS53yWNc","noticon":"_1ltcKruhjJfg35XliwrHaH"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@automattic/dops-components/client/components/button/style.scss
 ** module id = 204
 ** module chunks = 1
 **/